  <template>
    <div class="container mt-5">
<!--      <Loading v-if="transList==null"/>-->
<!--      <div v-else class="mt-4 ">-->
<!--        -->
<!--      </div>-->
      <TransactionTable :page="showTop"/>
    </div>
  </template>

  <script>
  import TransactionTable from "@/views/comp_table/transaction_table";
  // import Loading from "@/views/_frame/loading";
  export default {
  name: "index",
    components: {TransactionTable},
    data() {
      return {
        showTop:'showTop',
        transList:null,
        transTotal:0,
        address:null,
      }
    },
    methods: {
      async actionTranscation() {
        let v =this
        let params = {
          page: 1,
          size: 10000,
        }
        if(v.address){
          params.address = v.address
        }
        let result = await v.api('txsList',params,{
          vue: v,
          key_data: 'data',
        })
        // console.log('address-TransactionList',result)
        if (result.code==200) {

          this.transList=result.data.transactionList
          this.transTotal=result.data.total
          // console.log('total',  this.transTotal)
        }
      },
    },
    mounted() {
        this.address=this.$route.params.number
    }
  }
  </script>

  <style scoped lang="scss">

  </style>
